import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Button, css, Typography } from '@mui/material';
import { Link } from 'react-router';
import { ROUTES } from '../../../constants/RouteNameMapping';

interface ManageAccessConfigCardProps {
  title: string;
  route: string;
}

const manageAccessConfigCard = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  border: 2px solid #fff;
  min-width: 10rem;
  min-height: 10rem;
  background: #fff;
  &:hover {
    background: radial-gradient(
      100% 204.54% at 0% 0%,
      rgba(249, 250, 250, 0.8) 0%,
      rgba(255, 255, 255, 0.32) 100%
    );
  }
`;

export function ManageAccessConfigCard({ title, route }: ManageAccessConfigCardProps) {
  return (
    <Box css={manageAccessConfigCard}>
      <Typography variant={'body2'} noWrap={true}>
        {title}
      </Typography>
      <Button
        variant='contained'
        color='secondary'
        size='small'
        startIcon={<EditOutlinedIcon />}
        component={Link}
        to={route}
      >
        Edit
      </Button>
    </Box>
  );
}

export function ManageAccess() {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '8px 12px 12px',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Typography variant='h4' component='h1' gutterBottom>
        Manage Access
      </Typography>
      <Box sx={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
        <ManageAccessConfigCard title='Company Access' route={ROUTES.ADMIN_PANEL_MANAGE_ACCESS_COMPANY} />
        <ManageAccessConfigCard
          title='Grid Column Display'
          route={ROUTES.ADMIN_PANEL_MANAGE_ACCESS_COLUMN_GRID_DISPLAY}
        />
      </Box>
    </Box>
  );
}
